export default __webpack_public_path__ + "static/media/248103.eae1f260.webp";